module.exports = __webpack_public_path__ + "assets/840c7d1d67636033f646eb170ade1e53.mp3";